import { forwardRef } from "react";
import MaskedInput from "react-text-mask";

import OmniTextField from "./omniTextField";

const PhoneTextMask = forwardRef(function PhoneTextMask(props, ref) {
  const { ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={ref ? ref.inputElement : null}
      mask={[
        "(",
        /\d|\*/,
        /\d|\*/,
        /\d|\*/,
        ")",
        /\d|\*/,
        /\d|\*/,
        /\d|\*/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      showMask
      onClick={event => {
        let theIndex = event.currentTarget.value.indexOf(" ");
        if (theIndex >= 0) {
          event.currentTarget.setSelectionRange(theIndex, theIndex);
        }
      }}
    />
  );
});

const OmniPhoneNumberField = props => {
  const {
    children,
    classes,
    rowCount = 1,
    multiline = false,
    onChange = null,
    label = "Missing",
    type = "tel",
    size = "small",
    altInputComponent = PhoneTextMask,
    ...other
  } = props;

  return (
    <OmniTextField
      label={label}
      value={props.value}
      variant="outlined"
      color="secondary"
      onChange={event => {
        // event.target.value = fixValueEntered(event.target.value);
        if (onChange != null) {
          onChange(event);
        }
      }}
      onFocus={event => {
        event.target.select();
      }}
      onPaste={event => {
        let onlyNums = event.clipboardData.getData("text");
        onlyNums = onlyNums.replace(/[^0-9]/g, "");
        if (onlyNums.length > 10) {
          onlyNums = onlyNums.slice(onlyNums.length - 10);
        }
        let eventInfo = {
          target: { id: props.id, value: `${onlyNums}` },
        };
        onChange(eventInfo);
      }}
      margin="dense"
      autofill="off"
      //prevents AutoComplete Suggestions
      autoComplete="off"
      multiline={multiline}
      rows={rowCount}
      type={type}
      size={size}
      InputProps={{
        inputComponent: altInputComponent,
        autoComplete: "new-password",
      }}
      {...other}
    >
      {children}
    </OmniTextField>
  );
};

export default OmniPhoneNumberField;
